import { render, staticRenderFns } from "./auth-register-container.vue?vue&type=template&id=4f4d5f87&scoped=true&lang=pug"
import script from "./auth-register-container.js?vue&type=script&lang=js&external"
export * from "./auth-register-container.js?vue&type=script&lang=js&external"
import style0 from "./auth-register-container.vue?vue&type=style&index=0&id=4f4d5f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d5f87",
  null
  
)

export default component.exports